import { IBotUserDisplayData } from '@gem/models/userModel';

import { botCatalogModel } from 'APP/model/model';

export async function addBotToProfile(botId: string): Promise<IBotUserDisplayData | null> {
  try {
    return await botCatalogModel.addBotToProfile(botId);
  } catch {
    return null;
  }
}
